import { IconButton, Paper } from '@mui/material';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { PropsWithChildren, PureComponent } from 'react';

interface LayerCheckContainerProps {
  customClassName?: string;
}

interface LayerCheckContainerState {
  collapsed: boolean;
}

export default class LayerCheckContainer extends PureComponent<
  PropsWithChildren<LayerCheckContainerProps>,
  LayerCheckContainerState
> {
  state: LayerCheckContainerState = { collapsed: false };

  toggle = () => this.setState((prev) => ({ collapsed: !prev.collapsed }));

  render() {
    const { customClassName, children } = this.props;

    if (this.state.collapsed) {
      return (
        <IconButton
          size="small"
          onClick={this.toggle}
          aria-label="Expand layers panel"
          style={{
            position: 'absolute',
            top: 125,
            right: 10,
            zIndex: 1000,
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          }}
        >
          <MdChevronLeft size={20} />
        </IconButton>
      );
    }

    return (
      <Paper
        square
        className={customClassName}
        style={{ position: 'absolute', top: 125, right: 10, zIndex: 1000, width: 200, padding: 5 }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton size="small" onClick={this.toggle} aria-label="Collapse layers panel" style={{ padding: 2 }}>
            <MdChevronRight size={20} />
          </IconButton>
        </div>
        {children}
      </Paper>
    );
  }
}
